
export const UPDATE_FILTER_MEDIAGROUPS = 'UPDATE_FILTER_MEDIAGROUPS';
export const UPDATE_FILTER_SEGMENTS = 'UPDATE_FILTER_SEGMENTS';
export const UPDATE_FILTER_CATEGORIES = 'UPDATE_FILTER_CATEGORIES';
export const UPDATE_FILTER_TARGETS = 'UPDATE_FILTER_TARGETS';
export const UPDATE_FILTER_SEARCH = 'UPDATE_FILTER_SEARCH';
export const UPDATE_FILTER_AGE = 'UPDATE_FILTER_AGE';
export const UPDATE_FILTER_GENDER = 'UPDATE_FILTER_GENDER';
export const UPDATE_FILTER_REACH = 'UPDATE_FILTER_REACH';
export const UPDATE_FILTER_BUDGET = 'UPDATE_FILTER_BUDGET';




// WEBPACK FOOTER //
// ./src/data/filters/types.js